module.exports = __webpack_public_path__ + "img/Front_RAN_Compute.jpg";